export const LOADED = "books/loaded";
export const ADD_BOOK = "books/addBook";
export const REMOVE_BOOK = "books/removeBook";

export const EDIT_BOOK = "books/editBook";
export const UPDATE_BOOK = "books/updateBook";
